<template>
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">
            {{ $t(title) }}
          </h4>
          <p class="text-primary">
            {{ $t("app.modules.product_family.addEdit.sub_text") }}
          </p>
        </div>
        <div class="card-body">
          <ValidationObserver ref="formAdd" v-slot="{ handleSubmit }">
            <form @submit.prevent="handleSubmit(verifySave)">
              <div class="col-12">
                <div class="row">
                  <div class="col-4">
                    <fg-input
                      type="text"
                      :label="$t('app.modules.product_family.headers.name')"
                      v-model="product_family.productoPadre"
                    >
                    </fg-input>
                  </div>
                  <div class="col-4">
                    <div class="form-group has-label">
                      <label>{{
                        $t("app.modules.product_family.headers.category_name")
                      }}</label>
                      <el-select
                        :placeholder="
                          $t('app.modules.product_family.headers.category_name')
                        "
                        size="large"
                        @change="selectCategory"
                        v-model="
                          product_family.categoriaProducto_idCategoriaProducto
                        "
                      >
                        <el-option
                          v-for="category in categories"
                          :key="category.idCategoriaProducto"
                          :label="category.nombreCategoria"
                          :value="category.idCategoriaProducto"
                        >
                        </el-option>
                      </el-select>
                    </div>
                  </div>
                  <div class="col-4">
                    <div class="form-group has-label">
                      <label>{{
                        $t(
                          "app.modules.product_family.headers.subcategory_name"
                        )
                      }}</label>
                      <el-select
                        v-if="subcategories.length > 0"
                        v-model="
                          product_family.subcategoriaProducto_idSubcategoriaProducto
                        "
                        :placeholder="
                          $t(
                            'app.modules.product_family.headers.subcategory_name'
                          )
                        "
                        size="large"
                        allowCreate
                      >
                        <el-option
                          v-for="subcat in subcategories"
                          :key="subcat.idSubcategoriaProducto"
                          :label="subcat.nombreSubcategoria"
                          :value="subcat.idSubcategoriaProducto"
                        >
                        </el-option>
                      </el-select>
                    </div>
                  </div>
                </div>

                <div class="separate"></div>

                <div class="row">
                  <div class="col-12">
                    <div class="form-group has-label">
                      <label>{{
                        $t(
                          "app.modules.product_family.addEdit.headers.iconography"
                        )
                      }}</label>
                      <el-upload
                        action="#"
                        accept="image/*"
                        :auto-upload="false"
                        list-type="picture-card"
                        multiple
                        :file-list="fileList"
                        name="iconography"
                        :on-change="changeIconography"
                        :on-remove="changeIconography"
                      >
                        <i class="el-icon-plus"></i>
                      </el-upload>
                    </div>
                  </div>
                </div>

                <div class="separate"></div>

                <div v-for="lang in product_family.traducciones">
                  <item-traduccion
                    :key="lang.idFamiliaProductoTraduccion"
                    :traduccion="lang">
                  </item-traduccion>
                </div>

                <div class="separate"></div>

                <div class="row">
                  <div class="col-12">
                    <label>{{
                      $t(
                        "app.modules.product_family.addEdit.headers.group_properties"
                      )
                    }}</label>
                  </div>
                </div>
                <div v-for="(property, index) in product_family.propiedades">
                  <item-propiedad
                    :groups="groups"
                    :propiedad="property"
                    :index="index" @removeProperty="removeProperty($event)">
                  </item-propiedad>
                  <div class="separate"></div>
                </div>

                <div
                  class="row"
                  style="padding: 0 14px; cursor: pointer;"
                  @click="addProperty"
                >
                  <div class="col-12 new_prop"><i class="fa fa-plus"></i></div>
                </div>
              </div>

              <div
                slot="footer"
                style="margin-top: 10px; padding-top: 20px;border-top: outset;"
                class="row"
              >
                <div class="col-4" style="text-align: left">
                  {{ $t("app.modules.product_family.buttons.publish") }}
                  <n-switch v-model="product_family.publicado"></n-switch>
                </div>
                <div class="col-4" style="text-align: center">
                  <n-button
                    native-type="submit"
                    type="primary"
                    style="font-size: 1.2rem;"
                    @click="disabledButton = true"
                    :disabled="disabledButton">{{ $t("app.buttons.save") }}</n-button>
                </div>
                <div class="col-4" style="text-align: right">
                  <n-button
                    class="btn-secondary"
                    type="default"
                    @click.native="$router.push({name: 'Familias productos'})"
                    style="font-size: 1.2rem;">{{ $t("app.buttons.cancel") }}</n-button>
                </div>
              </div>
            </form>
          </ValidationObserver>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FamiliaProducto from "@/models/familiaProducto/FamiliaProducto";
import FamiliaProductoTraduccion from "@/models/familiaProducto/FamiliaProductoTraduccion";
import Idioma from "@/models/familiaProducto/Idioma";
import Propiedad from "@/models/familiaProducto/FamiliaProductoPropiedad";
import { mapState } from "vuex";
import { getResponse } from "@/util/utilities";

export default {
  components: {
    ItemTraduccion: () => import("./itemTraduccion"),
    ItemPropiedad: () => import("./itemProp")
  },
  computed: {
    ...mapState(["user", "availableLangs"]),
    subcategories() {
      let category = this.categories.find(c => c.idCategoriaProducto === this.product_family.categoriaProducto_idCategoriaProducto);
      return !!category && !!category.subcategorias ? category.subcategorias : [];
    }
  },
  created() {
    this.product_family.usuarios_idUsuario = this.user.idUsuario;
    this.product_family.traducciones = this.availableLangs.map((lang) => new FamiliaProductoTraduccion({
      idFamiliaProductoTraduccion: Math.random(),
      idiomas_idIdioma: lang.idIdioma,
      idioma: new Idioma({
        idIdioma: lang.idIdioma,
        idioma: lang.idioma,
        clave: lang.clave
      })
    }));
  },
  mounted() {
    this.init();
  },
  data() {
    return {
      disabledButton: false,
      product_family: new FamiliaProducto(),
      categories: [],
      groups: [],
      fileList: [],
      title: "app.modules.product_family.addEdit.title"
    };
  },
  methods: {
    init() {
      this.$swal.fire({
        title: this.$t("app.promps.wait"),
        html:
          '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
        showConfirmButton: false
      });
      this.getCategories();
      this.getGroupFamilies();

      if (!!this.$route.params.id) {
        this.title = "app.modules.product_family.addEdit.titleEdit";
        this.loadProductFamily(this.$route.params.id);
      }

      this.$swal.close();
    },
    async getCategories() {

      let request = await this.$http.post(route("CategoriaProducto/getCategoria"), { WithCategories: true, OnlyActives: true } );
      let response = getResponse(request, null);

      if(response){
        this.categories = response.categoriaProducto;
        let category = this.categories[0];
        this.product_family.categoriaProducto_idCategoriaProducto = category.idCategoriaProducto;
        if(!!category.subcategorias)
          this.product_family.subcategoriaProducto_idSubcategoriaProducto = category.subcategorias[0].idSubcategoriaProducto;
      }
      else this.notifyMessage("danger", this.$t("app.promps.error"));
    },
    async getGroupFamilies(){

      var payload = {
        id: 0,
        claveIdioma: this.$store.state.lang,
        usuario: 0,
        onlyActivesProps: true
      };

      let request = await this.$http.post(route("GrupoPropiedadFamiliaProducto/getGrupoPropiedadFamiliaProducto"), payload);
      let response = getResponse(request, null);

      if(response){
        this.groups = response.grupoPropiedadFamiliaProductos;
      }
      else this.notifyMessage("danger", this.$t("app.promps.error"));
    },
    async loadProductFamily(id){
      this.product_family.idFamiliaProducto = id;

      let data = new FormData();
      data.append("IdFamiliaProducto", id);

      let request = await this.$http.put(route("FamiliasProducto/getFamiliaProducto"), data);
      let response = getResponse(request, null);

      if(response){
        this.product_family = response.familiasProductos[0];

        if(!!this.product_family.iconografia){
          let icons = this.product_family.iconografia;
          let json = JSON.parse(icons);
          for (const el of json) {
            this.fileList.push({
              uid: el , name: 'imagen', url: el
            });
          }
          this.product_family.iconografia = this.fileList;
        }
      }
      else this.notifyMessage("danger", this.$t("app.promps.error"));
    },
    async verifySave(){

      this.disabledButton = true;
      this.$swal.fire({
        title: this.$t("app.promps.wait"),
        html:
          '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
        showConfirmButton: false
      });

      try{
        if(!!!this.product_family.productoPadre) throw new Error(this.$t('app.modules.product_family.errors.no_parent_product'));

        if(!!this.product_family.traducciones && this.product_family.traducciones.length > 0){
          for (const trad of this.product_family.traducciones) {
            if(!!!trad.descripcion) throw new Error(this.$t('app.modules.product_family.errors.no_description') + trad.idioma.idioma);
            //if(!!!trad.caracteristicasGenerales) throw new Error(this.$t('app.modules.product_family.errors.no_general_characteristics') + trad.idioma.idioma);
          }
        }

        if(!!this.product_family.propiedades && this.product_family.propiedades.length > 0){
          for (let i = 0; i < this.product_family.propiedades.length; i++) {
            let propiedad = this.product_family.propiedades[i];
            if(!!!propiedad.valorPropiedad) throw new Error(this.$t('app.modules.product_family.errors.no_property_value')+": "+(i+1));
          }
        }

        let response;
        if(!!this.$route.params.id){
          response = await this.saveEdit();
        }
        else response = await this.save();

        if(response){
          this.$router.push({name: "Familias productos"});
        }
        else this.disabledButton = false;
      }
      catch (e){
        this.notifyMessage('danger', e.message);
        this.disabledButton = false;
      }
      finally
      {
        this.$swal.close();
      }
    },
    async save(){

      let obj = {
        categoriaProducto_idCategoriaProducto: this.product_family.categoriaProducto_idCategoriaProducto,
        subcategoriaProducto_idSubcategoriaProducto: this.product_family.subcategoriaProducto_idSubcategoriaProducto,
        productoPadre: this.product_family.productoPadre,
        publicado: this.product_family.publicado,
        usuarios_idUsuario: this.product_family.usuarios_idUsuario,
        traducciones: [],
        propiedades: []
      }

      if(this.product_family.traducciones.length > 0){
        for (const idioma of this.product_family.traducciones) {
          obj.traducciones.push({
            descripcion: idioma.descripcion,
            caracteristicasGenerales: idioma.caracteristicasGenerales,
            idiomas_idIdioma: idioma.idiomas_idIdioma
          });
        }
      }

      if(this.product_family.propiedades.length > 0){
        for (let i = 0; i < this.product_family.propiedades.length; i++) {
          let property = this.product_family.propiedades[i];
          obj.propiedades.push({
            propiedadFamilia_idPropiedadFamiliaProducto: property.propiedadFamilia_idPropiedadFamiliaProducto,
            valorPropiedad: property.valorPropiedad instanceof File ? "file:"+i : property.valorPropiedad
          });
        }
      }

      let data = new FormData();
      data.append("param", JSON.stringify(obj));

      if(this.product_family.iconografia.length > 0){
        for (const icon of this.product_family.iconografia) {
          data.append("iconografia", icon);
        }
      }

      if(this.product_family.traducciones.length > 0){
        for (const idioma of this.product_family.traducciones) {
          data.append("traducciones."+idioma.idiomas_idIdioma+".ts", idioma.hojaTecnica);
          data.append("traducciones."+idioma.idiomas_idIdioma+".ss", idioma.hojaSeguridad);
        }
      }

      if(this.product_family.propiedades.length > 0){
        for (let i = 0; i < this.product_family.propiedades.length; i++) {
          let property = this.product_family.propiedades[i];
          if(property.valorPropiedad instanceof File){
            data.append("propiedades.file:"+i, property.valorPropiedad);
          }
        }
      }

      let request = await this.$http.post(route("FamiliasProducto/addFamiliaProducto"), data, { headers: { "Content-Type": "multipart/form-data" }});
      return getResponse(request, null);
    },
    async saveEdit(){
      let obj = {
        idFamiliaProducto: this.product_family.idFamiliaProducto,
        categoriaProducto_idCategoriaProducto: this.product_family.categoriaProducto_idCategoriaProducto,
        subcategoriaProducto_idSubcategoriaProducto: this.product_family.subcategoriaProducto_idSubcategoriaProducto,
        productoPadre: this.product_family.productoPadre,
        publicado: this.product_family.publicado,
        usuarios_idUsuario: this.product_family.usuarios_idUsuario,
        iconografia: "",
        traducciones: [],
        propiedades: []
      };

      let iconografia = [];
      if(!!this.product_family.iconografia && this.product_family.iconografia.length > 0){
        let list = [];
        for (const icon of this.product_family.iconografia) {
          if(!(icon instanceof File)){
            list.push(icon.uid);
          }
          else {
            iconografia.push(icon)
          }
        }
        obj.iconografia = JSON.stringify(list);
      }

      if(!!this.product_family.traducciones && this.product_family.traducciones.length > 0){
        for (const idioma of this.product_family.traducciones) {
          obj.traducciones.push({
            idFamiliaProductoTraduccion: idioma.idFamiliaProductoTraduccion,
            descripcion: idioma.descripcion,
            caracteristicasGenerales: idioma.caracteristicasGenerales,
            idiomas_idIdioma: idioma.idiomas_idIdioma,
            hojaTecnica: idioma.hojaTecnica instanceof File ? "" : idioma.hojaTecnica,
            hojaSeguridad: idioma.hojaSeguridad instanceof File ? "" : idioma.hojaSeguridad,
          });
        }
      }

      if(!!this.product_family.propiedades && this.product_family.propiedades.length > 0){
        for (let i = 0; i < this.product_family.propiedades.length; i++) {
          let property = this.product_family.propiedades[i];
          obj.propiedades.push({
            idFamiliaProductoPropiedad: property.idFamiliaProductoPropiedad,
            familiaProducto_idFamiliaProducto: this.product_family.idFamiliaProducto,
            propiedadFamilia_idPropiedadFamiliaProducto: property.propiedadFamilia_idPropiedadFamiliaProducto,
            valorPropiedad: property.valorPropiedad instanceof File ? "file:"+i : property.valorPropiedad
          });
        }
      }

      let data = new FormData();
      data.append("param", JSON.stringify(obj));

      iconografia.forEach(file => data.append("iconografia", file));

      if(!!this.product_family.traducciones && this.product_family.traducciones.length > 0){
        for (const idioma of this.product_family.traducciones) {
          if(idioma.hojaTecnica instanceof File)
            data.append("traducciones."+idioma.idiomas_idIdioma+".ts", idioma.hojaTecnica);
          if(idioma.hojaSeguridad instanceof File)
            data.append("traducciones."+idioma.idiomas_idIdioma+".ss", idioma.hojaSeguridad);
        }
      }

      if(!!this.product_family.propiedades && this.product_family.propiedades.length > 0){
        for (let i = 0; i < this.product_family.propiedades.length; i++) {
          let property = this.product_family.propiedades[i];
          if(property.valorPropiedad instanceof File){
            data.append("propiedades.file:"+i, property.valorPropiedad);
          }
        }
      }

      let request = await this.$http.post(route("FamiliasProducto/updateFamiliaProducto"), data, { headers: { "Content-Type": "multipart/form-data" }});
      return getResponse(request, null);
    },
    selectCategory(){
      let category = this.categories.find(c => c.idCategoriaProducto === this.product_family.categoriaProducto_idCategoriaProducto);
      if(category.subcategorias != null)
        this.product_family.subcategoriaProducto_idSubcategoriaProducto = category.subcategorias[0].idSubcategoriaProducto;
    },
    changeIconography(file, fileList){
      this.product_family.iconografia = [];
      for(let f of fileList){
        if(f.raw !== undefined)
          this.product_family.iconografia.push(f.raw);
        else
          this.product_family.iconografia.push(f);
      }
    },
    addProperty(){
      if(this.product_family.propiedades == null){
        this.product_family.propiedades = [];
      }

      this.product_family.propiedades.push(new Propiedad());
    },
    removeProperty(index)
    {
      this.product_family.propiedades.splice(index, 1);
    }
  }
};
</script>
<style>
label {
  font-size: 1rem !important;
  color: gray !important;
}
.has-success.has-label:after {
  top: 40px !important;
}
img {
  border-radius: 0;
}
.el-select-dropdown.el-popper{
  border-radius: 10px!important;
}
.form-group .el-select .el-input__inner{
  background-color: black !important;
}
</style>
<style scoped>
.separate {
  height: 1px;
  background: #f1f1f1;
  margin: 15px 0;
}
.el-upload__tip {
  color: #b9b9b9;
}
.new_prop {
  background: #fbfbfb;
  text-align: center;
  border-radius: 5px;
  padding: 10px;
}
</style>
